import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import SmallFractionDisplay from '../ui/SmallFractionDisplay';

export default class FeedbackTextDisplay extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.numDisplay1;
    this.numDisplay2;

    this.maxWidth = 0;

    this.currentItems = [];
    this.draggingTrash = [];

    this.sentenceContainer = this.scene.add.container();
    this.add(this.sentenceContainer);

    this.is = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.is'), 22).setCenterAlign()
      .setVisible(false);
    this.sentenceContainer.add(this.is);
    this.does = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.does'), 22).setCenterAlign()
      .setVisible(false);
    this.sentenceContainer.add(this.does);
    this.greater = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.greater'), 22).setCenterAlign()
      .setVisible(false);
    this.sentenceContainer.add(this.greater);
    this.lesser = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.lesser'), 22).setCenterAlign()
      .setVisible(false);
    this.sentenceContainer.add(this.lesser);
    this.equal = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.equal'), 22).setCenterAlign()
      .setVisible(false);
    this.sentenceContainer.add(this.equal);
    this.equals = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.equals'), 22).setCenterAlign()
      .setVisible(false);
    this.sentenceContainer.add(this.equals);
    this.not = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.not'), 22).setCenterAlign()
      .setVisible(false);
    this.sentenceContainer.add(this.not);
    this.than = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString('questions.than'), 22).setCenterAlign()
      .setVisible(false);
    this.sentenceContainer.add(this.than);

    this.itemBank = {
      is: this.is,
      does: this.does,
      greater: this.greater,
      lesser: this.lesser,
      equal: this.equal,
      equals: this.equals,
      not: this.not,
      than: this.than
    };

    this.number1 = this.scene.add.bitmapText(0, 0, 'asapBold', '1', 24).setVisible(false);
    this.sentenceContainer.add(this.number1);
    this.number2 = this.scene.add.bitmapText(0, 0, 'asapBold', '12', 24).setVisible(false);
    this.sentenceContainer.add(this.number2);

    if (gameData.GAME_TYPE !== 'jr') {
      this.fraction1 = new SmallFractionDisplay(this.scene, this).setVisible(false);
      this.fraction2 = new SmallFractionDisplay(this.scene, this).setVisible(false);
    }
  }

  cleanupCurrent() {
    if (this.numDisplay1) this.numDisplay1.setVisible(false);
    if (this.numDisplay2) this.numDisplay2.setVisible(false);
    if (this.fraction1) this.fraction1.setVisible(false);
    if (this.fraction2) this.fraction2.setVisible(false);
    const len = this.currentItems.length;
    for (let i = 0; i < len; i++) {
      this.currentItems[i].setVisible(false);
    }
    this.currentItems = [];
    this.maxWidth = 0;
  };

  alignCurrent() {
    let curX = 0;
    const spacer = 10;

    if (this.numDisplay1) {
      this.numDisplay1.setVisible(true);
      this.numDisplay1.x = curX;
      curX += this.numDisplay1 instanceof SmallFractionDisplay ? this.numDisplay1.width + spacer * 2 : this.numDisplay1.width + spacer;
      for (let i = 0; i < this.currentItems.length; i++) {
        this.currentItems[i].setVisible(true);
        this.currentItems[i].x = curX;
        curX += this.currentItems[i].width + spacer;
      }
    }
    if (this.numDisplay2) {
      this.numDisplay2.setVisible(true);
      this.numDisplay2.x = curX;
      curX += this.numDisplay2.width;
    }

    this.maxWidth = curX;
  };

  showFeedback(answerType, isCorrect, num1, num2) {
    this.cleanupCurrent();

    if (num1.type === gameData.GAMETYPE_WHOLE_NUMBERS || num1.type === gameData.GAMETYPE_DECIMALS || num1.type === null) {
      this.number1.text = num1.value.toString();
      this.numDisplay1 = this.number1;
    }
    else {
      this.fraction1.updateDisplay(num1.value);
      this.numDisplay1 = this.fraction1;
    }
    if (num2.type === gameData.GAMETYPE_WHOLE_NUMBERS || num2.type === gameData.GAMETYPE_DECIMALS || num2.type === null) {
      this.number2.text = num2.value.toString();
      this.numDisplay2 = this.number2;
    }
    else {
      this.fraction2.updateDisplay(num2.value);
      this.numDisplay2 = this.fraction2;
    }

    switch (answerType) {
      case gameData.EQ:
        this.buildEqualsFeedback(isCorrect);
        break;
      case gameData.LT:
        this.buildLesserFeedback(isCorrect);
        break;
      case gameData.GT:
        this.buildGreaterFeedback(isCorrect);
        break;
    }

    this.alignCurrent();
  };

  buildLesserFeedback(isCorrect) {
    const ib = this.itemBank;
    if (isCorrect) {
      this.currentItems = [ib.is, ib.lesser, ib.than];
    }
    else {
      this.currentItems = [];
      switch (ABCyaLib.Environment.instance.locale) {
        case ABCyaLib.Environment.LOCALES.esUS:
          this.currentItems.push(ib.not, ib.is);
          break;
        default:
          this.currentItems.push(ib.is, ib.not);
      }
      this.currentItems.push(ib.lesser, ib.than);
    }
  };

  buildGreaterFeedback(isCorrect) {
    const ib = this.itemBank;
    if (isCorrect) {
      this.currentItems = [ib.is, ib.greater, ib.than];
    }
    else {
      this.currentItems = [];
      switch (ABCyaLib.Environment.instance.locale) {
        case ABCyaLib.Environment.LOCALES.esUS:
          this.currentItems.push(ib.not, ib.is);
          break;
        default:
          this.currentItems.push(ib.is, ib.not);
      }
      this.currentItems.push(ib.greater, ib.than);
    }
  };

  buildEqualsFeedback(isCorrect) {
    const ib = this.itemBank;
    if (isCorrect) {
      this.currentItems = [ib.equals];
    }
    else {
      this.currentItems = [];
      switch (ABCyaLib.Environment.instance.locale) {
        case ABCyaLib.Environment.LOCALES.esUS:
          this.currentItems.push(ib.not, ib.is);
          break;
        default:
          this.currentItems.push(ib.does, ib.not);
      }
      this.currentItems.push(ib.equal);
    }
  };
}